export interface Description {
  description: string;
}
